import { Route, Routes } from "react-router-dom";
import NotFoundPage from "./routes/404";
import Administration from "./routes/Admin";
import AdminMachines from "./routes/AdminMachines";
import AdminDeletedMachines from "./routes/AdminMachines/DeletedMachines";
import NewMachine from "./routes/AdminMachines/NewMachine";
import CareerOverview from "./routes/Career";
import Career from "./routes/Career/career";
import ClarkOverview from "./routes/ClarkOverview";
import ClarkOverviewIFrame from "./routes/ClarkOverviewIFrame";
import Contact from "./routes/Contact";
import Home from "./routes/Home/index";
import Login from "./routes/Login";
import Machines from "./routes/Machines";
import MachineDetail from "./routes/Machines/machineDetail";
import OurServices from "./routes/OurServices";
import ServiceOrder from "./routes/ServiceOrder";
import Training from "./routes/Training";

const Router = () => {
  return (
    <Routes>
      <Route path="*" element={<NotFoundPage />} />
      <Route path="/" element={<Home />} />
      <Route path="/nase-sluzby" element={<OurServices />} />
      <Route path="/objednavka-servisu" element={<ServiceOrder />} />
      <Route path="/kariera" element={<CareerOverview />} />
      <Route path="/pracovni-pozice" element={<Career />} />
      <Route path="/kontakt" element={<Contact />} />
      <Route path="/bazarove-stroje" element={<Machines />} />
      <Route path="/flotila-clark" element={<ClarkOverviewIFrame />} />
      <Route path="/nove-stroje" element={<ClarkOverview />} />
      <Route path="/detail-stroje" element={<MachineDetail />} />
      <Route path="/skoleni" element={<Training />} />
      <Route path="/login" element={<Login />} />
      <Route path="/administration" element={<Administration />} />
      <Route path="/administration/bazarove-stroje" element={<AdminMachines />} />
      <Route path="/administration/bazarove-stroje/smazane-bazarove-stroje" element={<AdminDeletedMachines />} />
      <Route path="/administration/bazarove-stroje/novy-bazarovy-stroj" element={<NewMachine />} />
    </Routes>
  );
};

export default Router;
